import { WORKLENS_PRODUCT_TYPE } from '../model/productType';

import RestClient from './RestClient';

export interface AvailableProduct {
  activityCount: number;
  productType: WORKLENS_PRODUCT_TYPE;
  url?: string;
}

export interface AvailableSite {
  adminAccess: boolean;
  availableProducts: AvailableProduct[];
  cloudId: string;
  displayName: string;
  url: string;
}

export interface AvailableProductsResponse {
  sites: AvailableSite[];
}

export interface FeatureFlagsResponse {
  flags: { [s: string]: boolean };
}

class WorklensClient extends RestClient {
  constructor() {
    super({
      baseUrl: '/gateway/api/worklens',
    });
  }

  async getAvailableProducts(): Promise<AvailableProductsResponse> {
    return this.getResource<AvailableProductsResponse>('/api/available-products');
  }

  async getFeatureFlags(): Promise<FeatureFlagsResponse> {
    return this.getResource<FeatureFlagsResponse>('/api/features');
  }
}

export default new WorklensClient();
